import { Component } from '@theme/component';
 
/**
 * A custom element that manages the account login actions.
 *
 * @extends {Component}
 */
class AccountLoginActions extends Component {
  /**
   * @type {Element | null}
   */
  shopLoginButton = null;
 
  connectedCallback() {
    super.connectedCallback();
    this.shopLoginButton = this.querySelector('shop-login-button');
 
    if (this.shopLoginButton) {
      // We don't have control over the shop-login-button markup, so we need to set additional attributes here
      this.shopLoginButton.setAttribute('full-width', 'true');
      this.shopLoginButton.setAttribute('persist-after-sign-in', 'true');
      // Do this only if New Customer Account is ALWAYS the sign in option (and never Classic Customer Account)
      this.shopLoginButton.setAttribute('analytics-context', 'loginWithShopSelfServe');
      this.shopLoginButton.setAttribute('flow-version', 'account-actions-popover');
      // Always return to the RUNWAYHIM portal after a successful Shop OAuth
      // sign-in, regardless of which storefront page initiated the login.
      // (The previous value, `window.location.href`, sent customers back to
      // wherever the popover was opened from — usually the homepage — and
      // never to /pages/account.)
      this.shopLoginButton.setAttribute('return-uri', `${location.origin}/pages/account`);
 
      // After the OAuth handshake completes, navigate to the portal.
      // We need this manual navigation because Shop SDK's `return-uri`
      // attribute (set above) doesn't reliably navigate on its own from
      // non-account pages (e.g. /pages/vip-accept). We add a small
      // 900ms delay so Shopify's storefront session cookie has time to
      // commit before /pages/account renders — without the delay,
      // /pages/account renders as logged-out (the old double-sign-in
      // race we saw on the invite flow).
      this.shopLoginButton.addEventListener('completed', () => {
        setTimeout(() => {
          window.location.assign('/pages/account');
        }, 900);
      });
    }
  }
}
 
if (!customElements.get('account-login-actions')) {
  customElements.define('account-login-actions', AccountLoginActions);
}
 
 